import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import LineOnSideHeader from '~/components/atoms/LineOnSideHeader.vue';
import RatingStars from '~/components/molecules/Global/RatingStars.vue';

const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

const ProductStock = () => import(
/* webpackChunkName: "product-sheet" */
'~/components/atoms/Product/ProductStock.vue');

export default {
  name: 'ProductOffersModal',
  components: {
    MdmModal,
    LineOnSideHeader,
    RatingStars,
    ProductStock
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    offers: {
      type: Object,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      items: null
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    discountDeadline() {
      return '20/02/2020';
    }

  }),
  methods: {
    merchantUrl(reference) {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/m/").concat(reference);
    },

    currentPrice(offer) {
      if (offer.product.price.sales.amount) {
        return offer.product.price.sales.formatted;
      }

      return offer.product.price.base.formatted;
    }

  }
};